module.exports = function(media) {
	'use strict';
	media.directive('attachToPostModal',attachToPostModal);
	attachToPostModal.$inject=['getDataService','$rootScope','activeClass','refreshtokenService','config','$timeout','NgTableParams','serverError','postDataService','alertService','offlineError'];
	function attachToPostModal(getDataService,$rootScope,activeClass,refreshtokenService,config,$timeout,NgTableParams,serverError,postDataService,alertService,offlineError) {
		return {
			restrict: 'E',
			scope: {
		      currentPostObj:"="
		    },
		 	template: require('./partial/attach-to-post.html'),
		    link: function (scope, element, attrs) {
				var state = 'posts';
				var sortby ='date';
				var status = 'publish';
				var s;
				var page;
				var $data;
				$rootScope.modalShow = true;
				scope.checkboxes = {item:{}};
				scope.updateSelection = function(post_id, checked) {
			        var updateSelectionTree = function(posts) {
			          if(checked) {
			            for (var i=0; i<posts.length; i++){
			              if (posts[i]._id !== post_id) {
			                scope.checkboxes.item[posts[i]._id] = false;
			              }
			            }
			            scope.post_id = post_id;
			          } else {
			            scope.post_id = null;
			          }
			        }
			        updateSelectionTree(scope.dataGet);
			    } 
			    scope.selectRow = function(postId) {
			    	if(scope.checkboxes.item[postId]){
						scope.checkboxes.item[postId] = false;
					} else {
						scope.checkboxes.item[postId] = true;
					}
					$timeout(function() {
						scope.updateSelection(postId,scope.checkboxes.item[postId])
					},0);
			    } 
     			scope.selectPostToAttachMedia = function() {
     				if(scope.post_id) {
     					var postFunction = function() {	
						    postDataService.save({
					          param1:'attachments',
					          param2:'attach',
					          param3:scope.post_id
					        },{
					        	'ids': scope.currentPostObj.checkedPostsforAttach,
					        }).$promise.then(function(data){
					        	scope.currentPostObj.cancelAttachToPostModal();
								scope.currentPostObj.tableParams.reload();
					            alertService('success','Success ', data.message, 2000);
					        }, function(error){
								if(!window.navigator.onLine) {
									offlineError()
									$rootScope.hasLoaded = true;
									alertService('danger','Opps! ', 'Please check your internet connection and try again.');
									return
								}
								if(error.status ==401) {
									var promise = refreshtokenService.getAccessToken();
									promise.then(
									function(answer) {
										if(answer==200) {
										postFunction();
										}
									},
									function(error) {
										// report something
									},
									function(progress) {
									// report progress
									});
								} else if(error.status ==502) {
									serverError()
								} else {
									alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
								}
								scope.currentPostObj.cancelAttachToPostModal();
					        });
					    }
     					postFunction()
     				}
     			}
				scope.tableReloadFunction = function(page) {
			          scope.tableParams = new NgTableParams({
			              page: page || 1,
			              count: 20,
			              
			          }, {
			          getData: function(params) {
			            $rootScope.hasLoaded = false;
			            return getDataService.get({
			              param1: state,
			              param2: null,
			              s:s,
			              status: status,
			              page: params.page(),
			              limit: params.count(),
			              sortby: $rootScope.sortby,
			              sort : $rootScope.sort,
			              }).$promise.then(function(data){
			             
			              scope.emptyTable = false;
			              $rootScope.hasLoaded = true;
			              $data = data.posts;
			              scope.dataGet = data.posts;
			              if(data.posts.length == 0) {
			                scope.emptyTable = true;
			              }
			              for (var i=0; i<scope.dataGet.length; i++){
			                scope.checkboxes.item[scope.dataGet[i]._id] = false;
			              }
			              params.total(data.count);
			              params.numPages(data.max_pages);
			              jQuery('.goTo input').val("");
			              scope.search =function(value) {
			                if(value) {
			                s = value.toLowerCase();
			                } else {
			                  s = null;
			                }
			                page = 1;
			                params.page(page);
			                scope.tableReloadFunction();
			              }
			              
			              return $data;
			            }, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
			                if(error.status ==401) {
			                	var promise = refreshtokenService.getAccessToken();
				                promise.then(
			                    function(answer) {
				                    if(answer==200) {
				                      scope.tableReloadFunction(params.page());
				                    }
				                    // do something
				                },
				                function(error) {
				                },
				                function(progress) {
				                   // report progress
				                });
			              	} else if(error.status ==502) {
			                  serverError()
		                	} else if(error.status ==404) {
				                scope.emptyTable = true;
				            } else {
				                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
				            }	   
			                $rootScope.hasLoaded = true;
			            });
			          }    
			      });
			    }
			    scope.tableReloadFunction(); 
			}    
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/library/js/directive/attachToPostDirective.js
// module id = 514
// module chunks = 0